import React from 'react';
import Icon from 'flow/components/ui-components/Icon';

const FeatureItem = ({
    title,
    description,
}: {
    title: string;
    description: string;
}) => (
    <div className="flex items-start gap-3">
        <div className="bg-green mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full">
            <Icon iconKey="check" size="16px" className="text-white" />
        </div>
        <p className="text-[15px] leading-relaxed text-gray-200">
            <span className="font-semibold text-white">{title}</span>{' '}
            {description}
        </p>
    </div>
);

export default FeatureItem;
